
import Equipment from "../Equipment";

interface EquipmentStoreViewProps {
  onBack: () => void;
}

const EquipmentStoreView = ({ onBack }: EquipmentStoreViewProps) => {
  return (
    <div className="relative">
      {/* Embed the Equipment component with back handler */}
      <Equipment onBack={onBack} />
    </div>
  );
};

export default EquipmentStoreView;
